import { makeTextComponent } from './makeTextComponent'

export const Section = makeTextComponent(
  'font-size-large font-family-system font-weight-bold'
)
